export const ASSISTANT_DISPLAY_NAME = 'Frosty';

export const WELCOME_MESSAGE = `Hi, I'm ${ASSISTANT_DISPLAY_NAME}`;

export const WELCOME_SUBTITLE = 'I can help you check workflow status, look up task details, and more.';

export const INPUT_PLACEHOLDER = 'Ask about workflow status, executions, or tasks';

export const DEFAULT_SUGGESTIONS = [
	'Find me the owner of WF-123',
	'Status of FC_123',
	"Help me in selecting right tasks for",
	'How to create a Workflow',
];

export const PANEL_MIN_WIDTH = 320;
export const PANEL_MAX_WIDTH = 800;
export const PANEL_MIN_HEIGHT = 300;
export const PANEL_MAX_HEIGHT = 750;
export const PANEL_DEFAULT_WIDTH = 420;
export const PANEL_TOP_PADDING = 16;
export const PANEL_VIEWPORT_MARGIN = 32;

export const BUTTON_SIZE = 45;
export const BUTTON_PANEL_GAP = 8;
export const BUTTON_DEFAULT_POSITION = 24;

export const STORAGE_KEYS = {
	MESSAGES: 'chatbot_messages',
	SESSION_ID: 'chatbot_session_id',
	ACTOR_ID: 'chatbot_actor_id',
} as const;


export function generateMessageId(prefix: string): string {
	const unique =
		typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
			? crypto.randomUUID()
			: `${Date.now()}-${Math.random().toString(36).slice(2)}`;
	return `${prefix}-${unique}`;
}
